module.exports = __webpack_public_path__ + "img/commonly.e141fcf4.png";